import { AuthService } from '../../../services/auth/auth.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'dialog-credential-validation',
  templateUrl: './credential.component.html',
  styleUrls: ['./credential.component.css']
})
export class CredentialComponent implements OnInit {

  innerHeight: number = window.innerHeight;
  currentProvider: string|any;
  validProvider: string|any;
  registerForm: FormGroup|any;


  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<CredentialComponent>,
    private authService: AuthService
  ) {
    if (data) {
      this.registerForm = data.registerForm;
    }
  }

  ngOnInit() {
    this.currentProvider = this.authService.currentProvider;
    this.validProvider = (this.authService.afterErrProvider.split("."))[0];
  }

  signInDial(): void {

    const that = this;

    // Données nécessaire lors de l'inscription
    let lastname: string|any;
    let firstname: string|any;
    let countryId: number|any;
    let phone: string|any;

    // Si il y a formulaire renseigné alors on increment les variables avec les données du formulaire
    if (this.registerForm) {
      lastname = this.registerForm.get("lastname").value
      firstname = this.registerForm.get("firstname").value
      countryId = this.registerForm.get("id_country").value
      phone = this.registerForm.get("phone").value
    }

    that.authService.signInWithCredential(this.authService.afterErrProvider, phone, countryId, firstname, lastname).then(function (data) {
      that.closeDial(true);
    });


  }

  closeDial(result:any): void {
    this.dialogRef.close(result);
  }


}
